import React from 'react'
import Link from '@material-ui/core/Link'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Chart from 'react-apexcharts'

const useStyles = makeStyles({
    depositContext: {
        flex: 1,
    },
})

const options = {
    chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        stackType: '100%',
    },
    plotOptions: {
        bar: {
            horizontal: true,
        },
    },
    stroke: {
        width: 0,
        colors: ['#fff'],
    },
    xaxis: {
        categories: ['Apps'],
        labels: {
            show: true,
            style: {
                colors: ['#FEFEFE'],
                fontSize: '12px',
                fontFamily: 'Montserrat',
                fontWeight: 300,
                cssClass: 'apexcharts-yaxis-label',
            },
        },
    },
    tooltip: {
        y: {
            formatter: function(val) {
                return val.toFixed(2) + ' min';
            },
        },
        theme: 'dark'
    },
    fill: {
        opacity: 1,
    },
    grid: {
        xaxis: {
            lines: {
                show: false,
            },
        },
        yaxis: {
            lines: {
                show: false,
            },
        },
    },
    legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40,
    },
}

export default function BarIncidents(props) {
    const classes = useStyles()

    return (
        <React.Fragment>
            <Typography component='h2' variant='h6'>
                {props.title}
            </Typography>
            <div className='col percentage-chart'>
                {props.data &&
                    <Chart
                        options={options}
                        height={350}
                        series={props.data}
                        type='bar'
                    />
                }
            </div>
        </React.Fragment>
    )
}